var exports = {
  "z": "x1cb7f6e3--b49b55--root",
};

module.exports = exports;
